
import { supabase } from "@/integrations/supabase/client";

/**
 * API client for Slack Edge Function endpoints
 */
export const slackEdgeApiClient = {
  /**
   * Test a Slack connection with the provided credentials
   * @param webhookUrl The Slack incoming webhook URL
   * @param slackToken The Slack bot token
   * @returns A promise that resolves to the test results
   */
  testConnection: async (webhookUrl: string, slackToken: string) => {
    try {
      const { data, error } = await supabase.functions.invoke('slack-bot-test', {
        body: {
          webhook_url: webhookUrl,
          slack_token: slackToken,
          message: "Test connection from VirtuStaff.ai"
        }
      });
      
      if (error) {
        throw new Error(`Error testing connection: ${error.message}`);
      }
      
      return data;
    } catch (error) {
      console.error("Error testing Slack connection:", error);
      throw error;
    }
  },
  
  /**
   * Get the status of a Slack integration for an AI staff
   * @param aiStaffId The ID of the AI staff
   * @returns A promise that resolves to the integration status
   */
  getIntegrationStatus: async (aiStaffId: string) => {
    try {
      const { data, error } = await supabase.functions.invoke('slack-webhook-receiver', {
        body: {
          action: 'get_integration_status',
          ai_staff_id: aiStaffId
        }
      });
      
      if (error) {
        throw new Error(`Error getting integration status: ${error.message}`);
      }
      
      return data;
    } catch (error) {
      console.error("Error getting Slack integration status:", error);
      throw error;
    }
  }
};

export default slackEdgeApiClient;
